import { defineNuxtPlugin } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.directive('click-outside', {
        mounted(el, binding) {
            el.clickOutsideEvent = function(event: Event) {
                if (!(el === event.target || el.contains(event.target))) {
                    binding.value(event, el)
                }
            }
            document.addEventListener('click', el.clickOutsideEvent)
        },
        unmounted(el) {
            document.removeEventListener('click', el.clickOutsideEvent)
        },
    })

    nuxtApp.vueApp.directive('dropdown', {
        mounted(el) {
            el.clickEvent = function(event: Event) {
                if ((el === event.target || el.contains(event.target))) {
                    el.nextSibling?.classList?.toggle('absolute-hidden')
                }
            }
            document.addEventListener('click', el.clickEvent)
        },
        unmounted(el) {
            document.removeEventListener('click', el.clickEvent)
        },
    })
})
